module.exports = __webpack_public_path__ + "static/media/qr_icon.ad0a766b.svg";